<template>
  <div class="app-container">
    <div class="setting-box" v-loading="loading">
      <!-- <div class="setting">
        <div class="title">学校名称</div>
        <el-select size="mini" v-model="SchoolId" class="schoolselect" @change="getData()">
          <el-option v-for="item in schoolList" :key="item.SchoolId" :value="item.SchoolId" :label="item.SchoolName"></el-option>
        </el-select>
      </div> -->
      <div class="setting" v-if="list.length">
        <div class="title">话费设置</div>
        <div v-if="isMB">
          <div class="content mincost">
            每分钟收费
            <el-input size="small" type="number" v-model="list[0].Value"/>
            元
          </div>
          <div class="content mincost">
            外地每分钟
            <el-input size="small" type="number" v-model="list[6].Value"/>
            元
          </div>
        </div>
        <template v-else>
          <div class="content mincost">
            每分钟收费
            <el-input size="small" type="number" v-model="list[0].Value"/>
            元
          </div>
          <div class="content mincost">
            外地每分钟
            <el-input size="small" type="number" v-model="list[6].Value"/>
            元
          </div>
        </template>
      </div>
      <div class="setting" v-if="list.length">
        <div class="title">话费进位设置</div>
        <div class="content">
          每分钟话费时长
          <el-input size="mini" type="number" v-model="list[1].Value"/>
          秒（在通话时长达到该秒数后，自动进位到1分钟）</div>
      </div>
      <div class="setting" v-if="list.length">
        <div class="title">欠费设置</div>
        <div class="content">
          欠费额度
          <el-input size="mini" type="number" v-model="list[2].Value"/>
          元（0或正数，在欠费金额达到该额度后，不能再拨打电话）
        </div>
      </div>
      <div class="setting" v-if="list.length">
        <div class="title">余额不足提醒</div>
        <div class="content">
          余额不足
          <el-input size="mini" type="number" v-model="list[3].Value"/>
          元时提醒
        </div>
      </div>
      <div class="setting" v-if="list.length">
        <div class="title">每次充值</div>
        <div class="content">
          充值
          <el-input size="mini" type="number" v-model="list[4].Value"/>
          元
        </div>
      </div>
      <div class="setting" :class="isMB?'h60':''" v-if="list.length" style="border-bottom:1px #ddd solid;">
        <div class="title">月租（低消）</div>
        <div class="content">
          <el-input size="mini" type="number" v-model="list[5].Value"/>
          元
        </div>
      </div>
      <el-button class="setBn" @click="saveSetting" v-show="$permission.canWrite()" type="primary">保存</el-button>
    </div>
  </div>
</template>
<script>

export default {
  // name: "phonesetting",
  data() {
    return {
      list: [],
      api: require("@/api/consume/phonesetting").default,
      loading: false,
      // SchoolId: null,
      isMB: this.$store.state.isMB,
      // schoolList: [],
    }
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.api.list({}).then(res => {
        this.loading = false;
        if(res.Code==0) {
          this.list = res.Data
        } else {
          this.$message.error("获取设置失败，请刷新页面")
        }
      })
    },
    saveSetting() {
      let list = this.list
      if(!(list[0].Value>0||list[0].Value==='0')) {
        this.$message.error("每分钟收费金额需大于等于0")
        return
      }
      if(!(list[6].Value>0||list[6].Value==='0')) {
        this.$message.error("每分钟收费金额需大于等于0")
        return
      }
      if(list[1].Value<10||list[1].Value>60||list[1].Value%1!=0) {
        this.$message.error("进位数值需为10~60之间的整数")
        return
      }
      if(!(list[2].Value>0||list[2].Value==="0")) {
        this.$message.error("欠费额度需不小于0")
        return
      }
      if(!(list[3].Value>0||list[3].Value==="0")) {
        this.$message.error("余额提醒值需不小于0")
        return
      }
      if(!(list[4].Value>0)) {
        this.$message.error("每次充值金额需大于0")
        return
      }
      if(!(list[5].Value>0||list[5].Value==="0")) {
        this.$message.error("月租（低消）需不小于0")
        return
      }
      this.loading = true
      this.api.save(list).then(res => {
        this.loading = false
        if(res.Code==0) {
          this.$message.success("保存成功")
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.setting-box{
  width: 100%;
  height: 380px;
  font-size: 14px;
  position: relative;
  @media screen and (max-width: 767px) {
    border: 1px #ddd solid;
    height: 565px;
  }
  .setting{
    height: 65px;
    display: flex;
    // flex-wrap: wrap;
    align-items: center;
    padding-left: 20px;
    @media screen and (max-width: 767px) {
      height: 90px;
    }
    .title{
      width: 120px;
    }
    .content {
      width: calc(100% - 140px);
      // display: inline-block;
    }
    .mincost{
      width: 220px;
      @media screen and (max-width: 767px){
        width: fit-content
      }
    }
  }
  .h60{
    height: 60px;
    padding-bottom: 20px;
  }
  .el-input{
    width: 80px;
    margin: 0 5px;
    @media screen and (max-width: 767px) {
      width: 70px;
      margin: 0;
    }
    /deep/ .el-input__inner{
      border-top-color: #fff;
      border-left-color: #fff;
      border-right-color: #fff;
      border-bottom-color: #DCDFE6;
      border-radius: 0;
      text-align: center;
      color: #f11;
      font-size: 14px;
    }
  }
  .setBn{
    position: absolute;
    right: 20px;
    bottom: 10px;
  }
  .schoolselect{
    width: 180px;
    /deep/ .el-input__inner{
      border-top: none;
      border-left: none;
      border-right: none;
      border-radius: 0;
    }
  }
}
</style>